export default function IPStackService() {
  window.dataLayer = window.dataLayer || [];
  var getCountry = function() {
    var url = 'http://api.ipstack.com/check?access_key=f3287ae9e3cbb4c36c2cfff6b8b9fe28';
    var result = fetch(url);
    return result;
  };
  var visitorCountry = localStorage.getItem('CPVisitorCountry');
  if (visitorCountry) {
  setTimeout(function(){
    window.dataLayer.push({
      event: 'activeCampainLocationSet'
    })
  }, 1000);
  } else {
    getCountry().then(function(result){
      return result.json();
    }).then(function(data){
      if (typeof data == 'object' && data.hasOwnProperty('country_code')) {
        visitorCountry = data.country_code;
        localStorage.setItem('CPVisitorCountry', data.country_code);
      }
      setTimeout(function(){
        window.dataLayer.push({
          event: 'activeCampainLocationSet'
        })
      }, 1000);
    });
  }

}